import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { newrelic } from "@jti/fe-clients";
import { getAemModel } from "@jti/fe-common";
import { AemLanguagesProvider, AemModelProvider, store, UserAuth } from "@jti/user-auth";
import Layout from "./Layout";
import "@jti/ui/styles/base.scss";
console.info("<%= ".concat(process.env.SNAPSHOT_INFO, " %>"));
var container = document.getElementById("aem-user-auth");
newrelic.addRelease("user-auth", "".concat(process.env.NEW_RELIC_VERSION));
if (container) {
    var model = getAemModel(container);
    var languageModel = getAemModel(container, "desAppLanguages");
    var root = createRoot(container);
    root.render(_jsx(StrictMode, { children: _jsx(Layout, { children: _jsx(AemLanguagesProvider, { model: languageModel, children: _jsx(AemModelProvider, { model: model, children: _jsx(Provider, { store: store, children: _jsx(UserAuth, {}) }) }) }) }) }));
}
